"use strict";Object.defineProperty(exports, "__esModule", {value: true});

var _chunkQBYZPWDOcjs = require('./chunk-QBYZPWDO.cjs');

// src/utils/createJettonTransferMessage.ts
var _ton = require('@ton/ton');
function createJettonTransferMessage(params) {
  const builder = _ton.beginCell.call(void 0, );
  builder.storeUint(260734629, 32);
  builder.storeUint(params.queryId, 64);
  builder.storeCoins(BigInt(params.amount));
  builder.storeAddress(_chunkQBYZPWDOcjs.toAddress.call(void 0, params.destination));
  builder.storeAddress(
    params.responseDestination ? _chunkQBYZPWDOcjs.toAddress.call(void 0, params.responseDestination) : void 0
  );
  if (params.customPayload) {
    builder.storeBit(true);
    builder.storeRef(params.customPayload);
  } else {
    builder.storeBit(false);
  }
  builder.storeCoins(BigInt(params.forwardTonAmount));
  if (params.forwardPayload) {
    builder.storeBit(true);
    builder.storeRef(params.forwardPayload);
  } else {
    builder.storeBit(false);
  }
  return builder.endCell();
}



exports.createJettonTransferMessage = createJettonTransferMessage;
//# sourceMappingURL=chunk-KBINKP7D.cjs.map